/* ============================================================
   HIT: ajuda em janela (snippets/modal-ajuda.liquid), usada na página da raquete e no guia "Como escolher sua raquete".

   O comportamento de camada (rolagem travada, fundo inerte, foco preso, Esc, véu, foco de volta ao botão) é do HitCamadas
   (hit-camadas.js, carregado pelo layout com defer DEPOIS deste arquivo: por isso window.HitCamadas só é lido no clique).
   Aqui entram só o botão que abre, o X que fecha e a mudança da janela para o <body>.

   Por que mudar para o <body>: o HitCamadas deixa inerte tudo que leva data-fundo, menos quem CONTÉM a camada. A janela nasce
   dentro do <main data-fundo>; se ficasse lá, o conteúdo da página continuaria navegável por leitor de tela e por Tab.
   O snippet pode ser chamado mais de uma vez na página (um por tipo), então este arquivo pode vir mais de uma vez: a trava abaixo.
   ============================================================ */
(function () {
  'use strict';

  if (window.HitAjuda) return;
  window.HitAjuda = true;

  function janelaDe(botao) {
    var id = botao.getAttribute('data-ajuda-abrir');
    return id ? document.getElementById(id) : null;
  }

  // leva as janelas para o <body> (uma vez cada); o botão guarda a ligação pelo aria-controls, que não depende do lugar
  function levarAoBody() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ajuda]'), function (j) {
      if (j.parentNode !== document.body) document.body.appendChild(j);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', levarAoBody);
  else levarAoBody();

  document.addEventListener('click', function (ev) {
    var alvo = ev.target.closest ? ev.target.closest('[data-ajuda-abrir], .ajuda-fechar') : null;
    if (!alvo || !window.HitCamadas) return;
    if (alvo.hasAttribute('data-ajuda-abrir')) {
      var janela = janelaDe(alvo);
      if (!janela) return;
      levarAoBody();
      ev.preventDefault();
      window.HitCamadas.abrir(janela, alvo);
    } else {
      var aberta = alvo.closest('[data-ajuda]');
      if (aberta) window.HitCamadas.fechar(aberta);
    }
  });
})();
